import styled from 'styled-components';
import { DefaultButton } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';


export const CompareSortFilterCont = styled.div`
  display: flex;
  align-items: flex-end;
  margin: 24px 0 0 0;
`;

export const FilterDropCont = styled.div`
    width: 320px;
  position: relative;
  ${({ theme }: IThemeProvider) => `
      margin: 0 ${theme.layout.spacing.centy} 0 0;
  `}
`;

export const ClearButton = styled(DefaultButton)`
  border: none;
  position: relative;
  display: flex;
  align-items: center;
  svg {
    height: 20px;
  }
  ${({ theme }: IThemeProvider) => `
      background: ${theme.colors.neutral.primary[0]};
      color: ${theme.colors.neutral.primary[100]};
  `}
  &:disabled {
    opacity: 0.5;
  }
`;

export const ClearAction = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  text-decoration-line: underline;
  cursor: pointer;
  ${({theme}: IThemeProvider) => `
      color: ${theme.colors.support.blue[100]};
  `}
`;
